import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import classNames from 'classnames';
import debounce from 'lodash/debounce';
import Button from '../../../Button';
import { RecycleIcon } from '../../../Icons';

var TableHeader = function TableHeader(_ref) {
  var database = _ref.database,
      title = _ref.title,
      isOrderFrozen = _ref.isOrderFrozen;

  var _React$useState = React.useState(title),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  React.useEffect(function () {
    return setValue(title);
  }, [title]);
  var onClickContainer = React.useCallback(function (event) {
    event.stopPropagation();
    event.preventDefault();
    database.blur();
  }, [database]);
  var debounceTitleChange = React.useCallback(debounce(function (title) {
    return database.setAttributes({
      title: title
    });
  }, 300), [debounce, database]);
  var onTitleChange = React.useCallback(function (event) {
    var title = event.target.value;
    setValue(title);
    debounceTitleChange(title);
  }, [debounceTitleChange]);
  var onRefreshSort = React.useCallback(function () {
    return database.removeFrozenOrder();
  }, [database]);
  return React.createElement("div", {
    "data-qa": "database-header",
    onClick: onClickContainer,
    className: "flexbox background-shade-50 padding-medium radius-top-large"
  }, React.createElement("input", {
    "data-qa": "database-input",
    readOnly: database.readOnly,
    className: "flexbox-grow font-size-larger font-weight-medium shade-05",
    style: {
      minWidth: 74
    },
    placeholder: "Untitled",
    onChange: onTitleChange,
    value: value
  }), React.createElement(Button.Primary, {
    slim: true,
    className: classNames('header-sort-button transition', {
      disabled: !isOrderFrozen
    }),
    onClick: onRefreshSort
  }, React.createElement(RecycleIcon, {
    className: "margin-right-small",
    size: 16
  }), "Refresh sorting"));
};

export default React.memo(TableHeader);